export const REACT_APP_SITE_MODE = process.env.REACT_APP_SITE_MODE ?? 'Memorial';
export const BASE_CLOUD_URL = process.env.REACT_APP_BASE_CLOUD_URL ?? 'https://cvhmemorialquilt.blob.core.windows.net';
export const STRAPI_API_TOKEN = process.env.REACT_APP_STRAPI_API_TOKEN ?? '';
export const GTM_ID = process.env.REACT_APP_GTM_ID;
